import { StrapiBaseEntityModel } from 'entities/Strapi';

import { IMedia, MediaServer, MediaType } from './types';

export class MediaModel extends StrapiBaseEntityModel implements IMedia {
  readonly name;
  readonly url;
  readonly alt;
  readonly width;
  readonly height;
  readonly size;
  // .png/.svg/...
  readonly ext;
  // image/png...
  readonly mime;

  constructor(params: Omit<IMedia, 'type'>) {
    super(params);

    this.name = params.name;
    this.url = params.url;
    this.alt = params.alt;
    this.width = params.width;
    this.height = params.height;
    this.ext = params.ext;
    this.mime = params.mime;
    this.size = params.size;
  }

  get type(): MediaType {
    return this._getMediaTypeByMimeType(this.mime);
  }

  private readonly _getMediaTypeByMimeType = (mimeType: string): MediaType => {
    if (mimeType.startsWith('image/')) {
      return MediaType.img;
    }

    if (mimeType.startsWith('video/')) {
      return MediaType.video;
    }

    if (mimeType === 'application/pdf') {
      return MediaType.pdf;
    }

    return MediaType.other;
  };

  static fromJson({ alternativeText, ...raw }: MediaServer): MediaModel {
    return new MediaModel({
      ...raw,
      ...StrapiBaseEntityModel.getBaseEntityFromJson(raw),
      alt: alternativeText ?? '',
    });
  }

  static normalizeMedias(medias: Array<MediaServer>): Array<MediaModel> {
    return medias.map((media) => MediaModel.fromJson(media));
  }
}
